import { NutrientIdAndAll } from '@/types/Nutrient.types';

export const nutrientI18n: { [key in NutrientIdAndAll]: string } = {
  calories: 'calories',
  carbohydrates: 'carbohydrates',
  fat: 'fat',
  protein: 'protein',
  calcium: 'calcium',
  // chromium: 'chromium',
  copper: 'copper',
  // fluoride: 'fluoride',
  // iodine: 'iodine',
  iron: 'iron',
  magnesium: 'magnesium',
  manganese: 'manganese',
  // molybdenum: 'molybdenum',
  phosphorus: 'phosphorus',
  potassium: 'potassium',
  selenium: 'selenium',
  sodium: 'sodium',
  zinc: 'zinc',
  'vitamin-a': 'vitamin A',
  'vitamin-b1': 'vitamin B1 (thiamin)',
  'vitamin-b2': 'vitamin B2 (riboflavin)',
  'vitamin-b3': 'vitamin B3 (niacin)',
  'vitamin-b5': 'vitamin B5 (pantothenic acid)',
  'vitamin-b6': 'vitamin B6',
  // 'vitamin-b7': 'vitamin B7',
  'vitamin-b9': 'vitamin B9 (folate)',
  'vitamin-b12': 'vitamin B12',
  choline: 'choline',
  'vitamin-c': 'vitamin C',
  'vitamin-d': 'vitamin D',
  'vitamin-e': 'vitamin E',
  'vitamin-k': 'vitamin K',
  all: 'nutrients',
};
